(function(){
 function arrows(root){
  var track=root.querySelector('[data-ez-track]'),prev=root.querySelector('[data-ez-prev]'),next=root.querySelector('[data-ez-next]');
  if(!track||!prev||!next)return;
  function step(){var c=track.children[0];return c?c.getBoundingClientRect().width+16:300}
  function upd(){prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2}
  prev.onclick=function(){track.scrollBy({left:-step(),behavior:'smooth'})};
  next.onclick=function(){track.scrollBy({left:step(),behavior:'smooth'})};
  if(!track.__ez){track.__ez=1;track.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd)}
  upd();
 }
 function drawer(){
  var d=document.querySelector('[data-ez-drawer]');if(!d)return;
  document.querySelectorAll('[data-ez-drawer-open]').forEach(function(b){b.onclick=function(){d.hidden=false}});
  d.querySelectorAll('[data-ez-drawer-close]').forEach(function(b){b.onclick=function(){d.hidden=true}});
 }
 function pdp(root){
  if(root.__ez)return;root.__ez=1;
  var data=JSON.parse(root.querySelector('[data-ez-variants]').textContent);
  var form=root.querySelector('form');if(!form)return;
  var idIn=form.querySelector('[name=id]');
  var selects=[].slice.call(root.querySelectorAll('[data-option-index]'));
  var price=root.querySelector('[data-ez-price]'),sku=root.querySelector('[data-ez-sku]'),stock=root.querySelector('[data-ez-stock]'),btn=root.querySelector('[data-ez-atc]');
  var thr=parseInt(root.getAttribute('data-threshold'),10)||10;
  function find(){var vals=selects.map(function(s){return s.value});return data.find(function(v){return v.options.every(function(o,i){return o===vals[i]})})}
  function upd(){
   var v=find();
   if(!v){btn.disabled=true;btn.textContent=root.dataset.soldLabel;return}
   idIn.value=v.id;
   if(price)price.innerHTML=v.price+(v.compare?'<s>'+v.compare+'</s>':'');
   if(sku)sku.textContent=v.sku||'';
   if(stock)stock.textContent=(v.tracked&&v.available&&v.qty>0&&v.qty<=thr)?root.dataset.stockText.replace('[n]',v.qty):'';
   btn.disabled=!v.available;btn.textContent=v.available?root.dataset.addLabel:root.dataset.soldLabel;
   try{var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}catch(e){}
  }
  selects.forEach(function(s){s.addEventListener('change',upd)});
  root.querySelectorAll('[data-ez-qty]').forEach(function(b){b.addEventListener('click',function(){var i=form.querySelector('[name=quantity]');var n=(parseInt(i.value,10)||1)+parseInt(b.dataset.ezQty,10);i.value=Math.max(1,n)})});
  var back=root.querySelector('[data-ez-back]');
  if(back)back.addEventListener('click',function(){if(history.length>1)history.back();else location.href=back.dataset.fallback});
 }
 function related(root){
  if(root.__ez)return;root.__ez=1;var url=root.dataset.url;if(!url)return;
  fetch(url).then(function(r){return r.text()}).then(function(t){
   var d=document.createElement('div');d.innerHTML=t;
   var src=d.querySelector('[data-ez-track]'),dst=root.querySelector('[data-ez-track]');
   if(src&&src.children.length&&dst&&src.querySelector('a[href*="/products/"]')){dst.innerHTML=src.innerHTML;arrows(root)}
  }).catch(function(){});
 }
 function init(){
  document.querySelectorAll('[data-ez-slider]').forEach(arrows);
  drawer();
  document.querySelectorAll('[data-ez-pdp]').forEach(pdp);
  document.querySelectorAll('[data-ez-related]').forEach(related);
 }
 if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
 document.addEventListener('shopify:section:load',init);
})();
